/**
  Format text as a mac address to show
  @function formatMacAddress
  @param {String} value
  @returns {String}
*/
export const formatMacAddress = value => {
  if (!value) {
    return '';
  }
  value = value.replace(/:| |[^0-9^a-f]/gi, '').slice(0, 12);
  return (value.match(/.{1,2}/g) || []).join(' : ');
};

/**
  Normalize a mac address to store
  @function normalizeMacAddress
  @param {String} value
  @returns {String}
*/
export const normalizeMacAddress = value => value.replace(/ /g, '');

/**
  Normalize the permission values to store
  @function formatMacAddress
  @param {List} permissions
  @returns {List}
*/
export const normalizeUserPermissions = permissions => {
  const permissionsList = {
    Admin: false,
    Status: false,
    AddTags: false,
    EditDeleteTags: false,
    EditDeleteGroupsCategories: false
  };

  return permissions.reduce((map, permission) => {
    map[permission] = true;
    return map;
  }, permissionsList);
};



// WEBPACK FOOTER //
// ./src/utils/inputs/index.js